export const statusAttributesMapping = {
  urgent: { color: 'warning', label: 'Urgent' },
  confirmation_requested: { color: 'secondary', label: 'Offered' },
  past_due: { color: 'info', label: 'Past Due' },
  jyver_replied_no: { color: 'error', label: 'Declined' },
  jyver_confirmed: { color: 'success', label: 'Confirmed' },
  auto_confirmed: { color: 'success', label: 'Confirmed' },
};
